import { Res } from 'core/api';

export function getName(code: string): string {
	const getNameFn = codeToGetName[code];
	return getNameFn ? getNameFn() : code;

}

export const DEFAULT_CODE = 'ES';

const codeToGetName: Record<string, () => string> = {
	'AF': Res.Const.COUNTRY_CODE_AF,
	'AL': Res.Const.COUNTRY_CODE_AL,
	'DE': Res.Const.COUNTRY_CODE_DE,
	'AD': Res.Const.COUNTRY_CODE_AD,
	'AO': Res.Const.COUNTRY_CODE_AO,
	'AI': Res.Const.COUNTRY_CODE_AI,
	'AQ': Res.Const.COUNTRY_CODE_AQ,
	'AG': Res.Const.COUNTRY_CODE_AG,
	'SA': Res.Const.COUNTRY_CODE_SA,
	'DZ': Res.Const.COUNTRY_CODE_DZ,
	'AR': Res.Const.COUNTRY_CODE_AR,
	'AM': Res.Const.COUNTRY_CODE_AM,
	'AW': Res.Const.COUNTRY_CODE_AW,
	'AU': Res.Const.COUNTRY_CODE_AU,
	'AT': Res.Const.COUNTRY_CODE_AT,
	'AZ': Res.Const.COUNTRY_CODE_AZ,
	'BE': Res.Const.COUNTRY_CODE_BE,
	'BS': Res.Const.COUNTRY_CODE_BS,
	'BH': Res.Const.COUNTRY_CODE_BH,
	'BD': Res.Const.COUNTRY_CODE_BD,
	'BB': Res.Const.COUNTRY_CODE_BB,
	'BZ': Res.Const.COUNTRY_CODE_BZ,
	'BJ': Res.Const.COUNTRY_CODE_BJ,
	'BT': Res.Const.COUNTRY_CODE_BT,
	'BY': Res.Const.COUNTRY_CODE_BY,
	'MM': Res.Const.COUNTRY_CODE_MM,
	'BO': Res.Const.COUNTRY_CODE_BO,
	'BA': Res.Const.COUNTRY_CODE_BA,
	'BW': Res.Const.COUNTRY_CODE_BW,
	'BR': Res.Const.COUNTRY_CODE_BR,
	'BN': Res.Const.COUNTRY_CODE_BN,
	'BG': Res.Const.COUNTRY_CODE_BG,
	'BF': Res.Const.COUNTRY_CODE_BF,
	'BI': Res.Const.COUNTRY_CODE_BI,
	'CV': Res.Const.COUNTRY_CODE_CV,
	'KH': Res.Const.COUNTRY_CODE_KH,
	'CM': Res.Const.COUNTRY_CODE_CM,
	'CA': Res.Const.COUNTRY_CODE_CA,
	'TD': Res.Const.COUNTRY_CODE_TD,
	'CL': Res.Const.COUNTRY_CODE_CL,
	'CN': Res.Const.COUNTRY_CODE_CN,
	'CY': Res.Const.COUNTRY_CODE_CY,
	'VA': Res.Const.COUNTRY_CODE_VA,
	'CO': Res.Const.COUNTRY_CODE_CO,
	'KM': Res.Const.COUNTRY_CODE_KM,
	'CG': Res.Const.COUNTRY_CODE_CG,
	'CD': Res.Const.COUNTRY_CODE_CD,
	'KP': Res.Const.COUNTRY_CODE_KP,
	'KR': Res.Const.COUNTRY_CODE_KR,
	'CI': Res.Const.COUNTRY_CODE_CI,
	'CR': Res.Const.COUNTRY_CODE_CR,
	'HR': Res.Const.COUNTRY_CODE_HR,
	'CU': Res.Const.COUNTRY_CODE_CU,
	'CW': Res.Const.COUNTRY_CODE_CW,
	'DK': Res.Const.COUNTRY_CODE_DK,
	'DM': Res.Const.COUNTRY_CODE_DM,
	'EC': Res.Const.COUNTRY_CODE_EC,
	'EG': Res.Const.COUNTRY_CODE_EG,
	'SV': Res.Const.COUNTRY_CODE_SV,
	'AE': Res.Const.COUNTRY_CODE_AE,
	'ER': Res.Const.COUNTRY_CODE_ER,
	'SK': Res.Const.COUNTRY_CODE_SK,
	'SI': Res.Const.COUNTRY_CODE_SI,
	'ES': Res.Const.COUNTRY_CODE_ES,
	'US': Res.Const.COUNTRY_CODE_US,
	'EE': Res.Const.COUNTRY_CODE_EE,
	'ET': Res.Const.COUNTRY_CODE_ET,
	'PH': Res.Const.COUNTRY_CODE_PH,
	'FI': Res.Const.COUNTRY_CODE_FI,
	'FJ': Res.Const.COUNTRY_CODE_FJ,
	'FR': Res.Const.COUNTRY_CODE_FR,
	'GA': Res.Const.COUNTRY_CODE_GA,
	'GM': Res.Const.COUNTRY_CODE_GM,
	'GE': Res.Const.COUNTRY_CODE_GE,
	'GH': Res.Const.COUNTRY_CODE_GH,
	'GI': Res.Const.COUNTRY_CODE_GI,
	'GD': Res.Const.COUNTRY_CODE_GD,
	'GR': Res.Const.COUNTRY_CODE_GR,
	'GL': Res.Const.COUNTRY_CODE_GL,
	'GP': Res.Const.COUNTRY_CODE_GP,
	'GU': Res.Const.COUNTRY_CODE_GU,
	'GT': Res.Const.COUNTRY_CODE_GT,
	'GF': Res.Const.COUNTRY_CODE_GF,
	'GG': Res.Const.COUNTRY_CODE_GG,
	'GN': Res.Const.COUNTRY_CODE_GN,
	'GQ': Res.Const.COUNTRY_CODE_GQ,
	'GW': Res.Const.COUNTRY_CODE_GW,
	'GY': Res.Const.COUNTRY_CODE_GY,
	'HT': Res.Const.COUNTRY_CODE_HT,
	'HN': Res.Const.COUNTRY_CODE_HN,
	'HK': Res.Const.COUNTRY_CODE_HK,
	'HU': Res.Const.COUNTRY_CODE_HU,
	'IN': Res.Const.COUNTRY_CODE_IN,
	'ID': Res.Const.COUNTRY_CODE_ID,
	'IR': Res.Const.COUNTRY_CODE_IR,
	'IQ': Res.Const.COUNTRY_CODE_IQ,
	'IE': Res.Const.COUNTRY_CODE_IE,
	'BV': Res.Const.COUNTRY_CODE_BV,
	'IM': Res.Const.COUNTRY_CODE_IM,
	'CX': Res.Const.COUNTRY_CODE_CX,
	'NF': Res.Const.COUNTRY_CODE_NF,
	'IS': Res.Const.COUNTRY_CODE_IS,
	'BM': Res.Const.COUNTRY_CODE_BM,
	'KY': Res.Const.COUNTRY_CODE_KY,
	'CC': Res.Const.COUNTRY_CODE_CC,
	'CK': Res.Const.COUNTRY_CODE_CK,
	'AX': Res.Const.COUNTRY_CODE_AX,
	'FO': Res.Const.COUNTRY_CODE_FO,
	'GS': Res.Const.COUNTRY_CODE_GS,
	'HM': Res.Const.COUNTRY_CODE_HM,
	'MV': Res.Const.COUNTRY_CODE_MV,
	'FK': Res.Const.COUNTRY_CODE_FK,
	'MP': Res.Const.COUNTRY_CODE_MP,
	'MH': Res.Const.COUNTRY_CODE_MH,
	'PN': Res.Const.COUNTRY_CODE_PN,
	'SB': Res.Const.COUNTRY_CODE_SB,
	'TC': Res.Const.COUNTRY_CODE_TC,
	'UM': Res.Const.COUNTRY_CODE_UM,
	'VG': Res.Const.COUNTRY_CODE_VG,
	'VI': Res.Const.COUNTRY_CODE_VI,
	'IL': Res.Const.COUNTRY_CODE_IL,
	'IT': Res.Const.COUNTRY_CODE_IT,
	'JM': Res.Const.COUNTRY_CODE_JM,
	'JP': Res.Const.COUNTRY_CODE_JP,
	'JE': Res.Const.COUNTRY_CODE_JE,
	'JO': Res.Const.COUNTRY_CODE_JO,
	'KZ': Res.Const.COUNTRY_CODE_KZ,
	'KE': Res.Const.COUNTRY_CODE_KE,
	'KG': Res.Const.COUNTRY_CODE_KG,
	'KI': Res.Const.COUNTRY_CODE_KI,
	'KW': Res.Const.COUNTRY_CODE_KW,
	'LB': Res.Const.COUNTRY_CODE_LB,
	'LA': Res.Const.COUNTRY_CODE_LA,
	'LS': Res.Const.COUNTRY_CODE_LS,
	'LV': Res.Const.COUNTRY_CODE_LV,
	'LR': Res.Const.COUNTRY_CODE_LR,
	'LY': Res.Const.COUNTRY_CODE_LY,
	'LI': Res.Const.COUNTRY_CODE_LI,
	'LT': Res.Const.COUNTRY_CODE_LT,
	'LU': Res.Const.COUNTRY_CODE_LU,
	'MX': Res.Const.COUNTRY_CODE_MX,
	'MC': Res.Const.COUNTRY_CODE_MC,
	'MO': Res.Const.COUNTRY_CODE_MO,
	'MK': Res.Const.COUNTRY_CODE_MK,
	'MG': Res.Const.COUNTRY_CODE_MG,
	'MY': Res.Const.COUNTRY_CODE_MY,
	'MW': Res.Const.COUNTRY_CODE_MW,
	'ML': Res.Const.COUNTRY_CODE_ML,
	'MT': Res.Const.COUNTRY_CODE_MT,
	'MA': Res.Const.COUNTRY_CODE_MA,
	'MQ': Res.Const.COUNTRY_CODE_MQ,
	'MU': Res.Const.COUNTRY_CODE_MU,
	'MR': Res.Const.COUNTRY_CODE_MR,
	'YT': Res.Const.COUNTRY_CODE_YT,
	'FM': Res.Const.COUNTRY_CODE_FM,
	'MD': Res.Const.COUNTRY_CODE_MD,
	'MN': Res.Const.COUNTRY_CODE_MN,
	'ME': Res.Const.COUNTRY_CODE_ME,
	'MS': Res.Const.COUNTRY_CODE_MS,
	'MZ': Res.Const.COUNTRY_CODE_MZ,
	'NA': Res.Const.COUNTRY_CODE_NA,
	'NR': Res.Const.COUNTRY_CODE_NR,
	'NP': Res.Const.COUNTRY_CODE_NP,
	'NI': Res.Const.COUNTRY_CODE_NI,
	'NE': Res.Const.COUNTRY_CODE_NE,
	'NG': Res.Const.COUNTRY_CODE_NG,
	'NU': Res.Const.COUNTRY_CODE_NU,
	'NO': Res.Const.COUNTRY_CODE_NO,
	'NC': Res.Const.COUNTRY_CODE_NC,
	'NZ': Res.Const.COUNTRY_CODE_NZ,
	'OM': Res.Const.COUNTRY_CODE_OM,
	'NL': Res.Const.COUNTRY_CODE_NL,
	'PK': Res.Const.COUNTRY_CODE_PK,
	'PW': Res.Const.COUNTRY_CODE_PW,
	'PS': Res.Const.COUNTRY_CODE_PS,
	'PA': Res.Const.COUNTRY_CODE_PA,
	'PG': Res.Const.COUNTRY_CODE_PG,
	'PY': Res.Const.COUNTRY_CODE_PY,
	'PE': Res.Const.COUNTRY_CODE_PE,
	'PF': Res.Const.COUNTRY_CODE_PF,
	'PL': Res.Const.COUNTRY_CODE_PL,
	'PT': Res.Const.COUNTRY_CODE_PT,
	'PR': Res.Const.COUNTRY_CODE_PR,
	'QA': Res.Const.COUNTRY_CODE_QA,
	'GB': Res.Const.COUNTRY_CODE_GB,
	'CF': Res.Const.COUNTRY_CODE_CF,
	'CZ': Res.Const.COUNTRY_CODE_CZ,
	'DO': Res.Const.COUNTRY_CODE_DO,
	'SS': Res.Const.COUNTRY_CODE_SS,
	'RE': Res.Const.COUNTRY_CODE_RE,
	'RW': Res.Const.COUNTRY_CODE_RW,
	'RO': Res.Const.COUNTRY_CODE_RO,
	'RU': Res.Const.COUNTRY_CODE_RU,
	'EH': Res.Const.COUNTRY_CODE_EH,
	'WS': Res.Const.COUNTRY_CODE_WS,
	'AS': Res.Const.COUNTRY_CODE_AS,
	'BL': Res.Const.COUNTRY_CODE_BL,
	'KN': Res.Const.COUNTRY_CODE_KN,
	'SM': Res.Const.COUNTRY_CODE_SM,
	'MF': Res.Const.COUNTRY_CODE_MF,
	'PM': Res.Const.COUNTRY_CODE_PM,
	'VC': Res.Const.COUNTRY_CODE_VC,
	'SH': Res.Const.COUNTRY_CODE_SH,
	'LC': Res.Const.COUNTRY_CODE_LC,
	'ST': Res.Const.COUNTRY_CODE_ST,
	'SN': Res.Const.COUNTRY_CODE_SN,
	'RS': Res.Const.COUNTRY_CODE_RS,
	'SC': Res.Const.COUNTRY_CODE_SC,
	'SL': Res.Const.COUNTRY_CODE_SL,
	'SG': Res.Const.COUNTRY_CODE_SG,
	'SX': Res.Const.COUNTRY_CODE_SX,
	'SY': Res.Const.COUNTRY_CODE_SY,
	'SO': Res.Const.COUNTRY_CODE_SO,
	'LK': Res.Const.COUNTRY_CODE_LK,
	'ZA': Res.Const.COUNTRY_CODE_ZA,
	'SD': Res.Const.COUNTRY_CODE_SD,
	'SE': Res.Const.COUNTRY_CODE_SE,
	'CH': Res.Const.COUNTRY_CODE_CH,
	'SR': Res.Const.COUNTRY_CODE_SR,
	'SJ': Res.Const.COUNTRY_CODE_SJ,
	'SZ': Res.Const.COUNTRY_CODE_SZ,
	'TJ': Res.Const.COUNTRY_CODE_TJ,
	'TH': Res.Const.COUNTRY_CODE_TH,
	'TW': Res.Const.COUNTRY_CODE_TW,
	'TZ': Res.Const.COUNTRY_CODE_TZ,
	'IO': Res.Const.COUNTRY_CODE_IO,
	'TF': Res.Const.COUNTRY_CODE_TF,
	'TL': Res.Const.COUNTRY_CODE_TL,
	'TG': Res.Const.COUNTRY_CODE_TG,
	'TK': Res.Const.COUNTRY_CODE_TK,
	'TO': Res.Const.COUNTRY_CODE_TO,
	'TT': Res.Const.COUNTRY_CODE_TT,
	'TN': Res.Const.COUNTRY_CODE_TN,
	'TM': Res.Const.COUNTRY_CODE_TM,
	'TR': Res.Const.COUNTRY_CODE_TR,
	'TV': Res.Const.COUNTRY_CODE_TV,
	'UA': Res.Const.COUNTRY_CODE_UA,
	'UG': Res.Const.COUNTRY_CODE_UG,
	'UY': Res.Const.COUNTRY_CODE_UY,
	'UZ': Res.Const.COUNTRY_CODE_UZ,
	'VU': Res.Const.COUNTRY_CODE_VU,
	'VE': Res.Const.COUNTRY_CODE_VE,
	'VN': Res.Const.COUNTRY_CODE_VN,
	'WF': Res.Const.COUNTRY_CODE_WF,
	'YE': Res.Const.COUNTRY_CODE_YE,
	'DJ': Res.Const.COUNTRY_CODE_DJ,
	'ZM': Res.Const.COUNTRY_CODE_ZM,
	'ZW': Res.Const.COUNTRY_CODE_ZW
};